import axios from './axios';

export interface CreateUserDto {
  name: string;
  email: string;
  password: string;
  role: 'super_admin' | 'manager';
  company?: string;
  permissions?: string[];
}

export interface UpdateUserDto {
  name?: string;
  email?: string;
  password?: string;
  permissions?: string[];
}

export interface User {
  _id: string;
  name: string;
  email: string;
  role: string;
  permissions?: string[];
  createdAt: string;
  updatedAt: string;
}

export interface UserResponse {
  status: string;
  data: {
    users: User[];
  };
}

export const userService = {
  // Tüm kullanıcıları getir
  async getAllUsers(): Promise<User[]> {
    const response = await axios.get<UserResponse>('/auth/admins');
    return response.data.data.users;
  },

  // Yeni kullanıcı oluştur
  async createUser(data: CreateUserDto) {
    const response = await axios.post('/auth/admins', data);
    return response.data.data.admin;
  },

  // Kullanıcı sil
  async deleteUser(id: string): Promise<void> {
    await axios.delete(`/auth/admins/${id}`);
  },

  // Yönetici güncelle
  async updateAdmin(id: string, data: UpdateUserDto): Promise<User> {
    const response = await axios.patch(`/auth/admins/${id}`, data);
    return response.data.data.admin;
  },

  // Yönetici rolünü güncelle
  async updateUserRole(id: string, role: string): Promise<User> {
    const response = await axios.patch(`/auth/admins/${id}/role`, { role });
    return response.data.data.admin;
  },

  // Yöneticiyi firmadan kaldır
  async removeAdminFromCompany(adminId: string): Promise<void> {
    await axios.delete(`/auth/admins/${adminId}/company`);
  }
};
